import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ConfirmTextButton from '../atoms/ConfirmTextButton';
import RegisterTextButton from '../atoms/RegisterTextButton';

const styles = {};

const enhance = compose(pure);

const ShopTableBody = enhance(
  ({
    identities,
    emptyRows,
    page,
    rowsPerPage,
    registerOpenAction,
    confirmOpenAction,
    roles
  }) => {
    return (
      <TableBody>
        {identities
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(result => {
            const checkRegisterEnabled = status =>
              status === 'UNREGISTERED' || status === 'REJECTION';
            const checkConfirmEnabled = status =>
              status !== 'UNREGISTERED' ||
              status === 'RESERVED' ||
              status === 'REJECTION' ||
              status === 'NG';
            const params = {
              id: result.identityId
            };
            return (
              <TableRow key={result.identityId}>
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>
                    <RegisterTextButton
                      params={params}
                      onClickAction={registerOpenAction}
                      enabled={checkRegisterEnabled(result.status)}
                    />
                  </TableCell>
                )}
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>
                    <ConfirmTextButton
                      params={result}
                      onClickAction={confirmOpenAction}
                      enabled={checkConfirmEnabled(result.status)}
                    />
                  </TableCell>
                )}
                <TableCell>{result.statusStr}</TableCell>
                <TableCell>{result.ngReason}</TableCell>
                <TableCell>{result.groupName}</TableCell>
                <TableCell>{result.address}</TableCell>
                <TableCell>{result.email}</TableCell>
                <TableCell>{result.phone}</TableCell>
                <TableCell>{result.fax}</TableCell>
                <TableCell>{result.groupTypeStr}</TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
